module.exports = __webpack_public_path__ + "img/arrow.svg?953e1d89568d2e81e7a5a7221d07e076";